export async function changeUserLang(api, language) {
  const { data: data } = await api.post(`change-user-lang`, language);
  return { data };
}

export async function acceptPrivacyPolicy(api) {
  const { data: data } = await api.post(`accept-privacy-policy`);
  return { data };
}

export async function logoutVue(api) {
  const { data: data } = await api.post(`vue-logout`);
  return { data };
}
